<template>
  <div class="image-display py-[80px]">
    <ModuleTitle>{{ $t('wo-de-xing-xiang-zhan-shi') }}</ModuleTitle>
    <div
      class="mt-[46px] sm:mt-[7.5vw] flex justify-center sm:block w-[1200px] sm:w-full mx-auto"
    >
      <div
        v-for="(video, index) in character?.preview_videos"
        :key="video"
        class="display-video sm:h-[50vw]"
      >
        <Media
          :ref="(instance: any) => (videos[index] = instance)"
          :src="video"
          :poster="posters[index]"
          class="w-full h-full"
          @mouseover="onmouseover(index)"
          @ended="playNext(index)"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import ModuleTitle from '../module-title.vue'
import FlatBtn from '../flat-btn.vue'
import Media from './media.vue'
import type { Character } from '~/api/interface/character'
const { isMobile } = useDevice()

interface ImageDisplayProps {
  character?: Character | null
}

const props = defineProps<ImageDisplayProps>()

const _createWork = inject<(source?: SOURCE) => void>('createWork')
const _changeImage = inject<(source?: SOURCE) => void>('changeImage')

const resourceLocation = injectResourceLocation()

const wxPoster = [
  getFeUrl('/youyan-platform/png/character-video-mask3.png'),
  getFeUrl('/youyan-platform/png/character-video-mask4.png'),
]

const posters = ref<string[]>([])

function createWork() {
  _createWork?.(resourceLocation?.source)
}

function changeImage() {
  _changeImage?.(resourceLocation?.source)
}

const videos = ref<any[]>([])

const bg = `url(${transformImage(
  getFeUrl('/youyan-platform/png/digital-human-middle.png')
)})`

function play(index: number) {
  videos.value.forEach((item, _index) => {
    if (_index !== index) {
      item.pause()
    }
  })

  videos.value[index]?.play()
}

function onmouseover(index: number) {
  play(index)
}

function playNext(index: number) {
  if (!props.character?.preview_videos?.length) {
    return
  }

  const nextIndex =
    index >= props.character.preview_videos.length - 1 ? 0 : index + 1
  play(nextIndex)
}

onMounted(() => {
  if (props.character?.preview_videos?.length) {
    play(0)
    if (isMobile) {
      posters.value = wxPoster
    }
  }
})
</script>
<style lang="scss" scoped>
.image-display {
  background: v-bind(bg) no-repeat;
  background-size: 100% 100%;
  // height: 48vw;
  @media (max-width: 680px) {
    background-size: contain;
    background-position: center;
  }

  .display-video {
    border: 4px solid var(--back-4);
    border-radius: 16px;
    overflow: hidden;
    z-index: 100;
    margin: 20px;
    flex: 1;
    position: relative;
  }
}
</style>
